module.exports = __webpack_public_path__ + "img/icon-payment-sms.71aae041.png";